import create from "zustand";

interface FiltersStore<T = any> {
  value: T;
  count: number;
  isOpen: boolean;
  updateCount: (count: number) => void;
  close: () => void;
  open: () => void;
  update: (v: T) => void;
  reset: () => void;
}

export const useFiltersStore = create<FiltersStore>((set) => ({
  value: {},
  count: 0,
  isOpen: false,
  close: () => {
    set(() => ({ isOpen: false }));
  },
  updateCount: (count: number) => {
    set(() => ({ count }));
  },
  open: () => {
    set(() => ({ isOpen: true }));
  },
  update: (value: any) => {
    set(() => ({ value }));
  },
  reset: () => {
    set(() => ({ value: {} }));
  },
}));
